import styled from 'astroturf/react'
import { Form } from '@calendly/form'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _ContentWrapper from "styles-ContentWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=ContentWrapper";
import _LeftColumn from "styles-LeftColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=LeftColumn";
import _RightColumn from "styles-RightColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=RightColumn";
import _FormWrapper from "styles-FormWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FormWrapper";
import _StyledForm from "styles-StyledForm.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=StyledForm";
import _PaymentSection from "styles-PaymentSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PaymentSection";
import _PaymentSectionTitle from "styles-PaymentSectionTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PaymentSectionTitle";
import _TotalDueSection from "styles-TotalDueSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueSection";
import _TotalDueLabel from "styles-TotalDueLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueLabel";
import _TotalDueAmount from "styles-TotalDueAmount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueAmount";
import _FormFieldsWrapper from "styles-FormFieldsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FormFieldsWrapper";
import _BottomSection from "styles-BottomSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=BottomSection";
import _PageContainer from "styles-PageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PageContainer";
import _InvoiceHeader from "styles-InvoiceHeader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeader";
import _InvoiceHeaderImageContainer from "styles-InvoiceHeaderImageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImageContainer";
import _InvoiceHeaderImage from "styles-InvoiceHeaderImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImage";
import _InvoiceHeaderImagePlaceholder from "styles-InvoiceHeaderImagePlaceholder.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImagePlaceholder";
import _InvoiceHeaderRight from "styles-InvoiceHeaderRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderRight";
import _InvoiceNumberLabel from "styles-InvoiceNumberLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNumberLabel";
import _InvoiceLeftColumnContent from "styles-InvoiceLeftColumnContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLeftColumnContent";
import _InvoicePaidWatermark from "styles-InvoicePaidWatermark.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidWatermark";
import _InvoicePaidStamp from "styles-InvoicePaidStamp.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidStamp";
import _InvoiceDetails from "styles-InvoiceDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetails";
import _InvoiceDetailLabel from "styles-InvoiceDetailLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailLabel";
import _InvoiceDetailBodyLine from "styles-InvoiceDetailBodyLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailBodyLine";
import _InvoiceDetailColumn from "styles-InvoiceDetailColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailColumn";
import _InvoiceDetailColumnRight from "styles-InvoiceDetailColumnRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailColumnRight";
import _InvoiceDetailDateText from "styles-InvoiceDetailDateText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailDateText";
import _InvoiceDueDateBlock from "styles-InvoiceDueDateBlock.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDueDateBlock";
import _InvoiceDetailDateSplitRow from "styles-InvoiceDetailDateSplitRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailDateSplitRow";
import _InvoiceDetailDateSplitColumn from "styles-InvoiceDetailDateSplitColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailDateSplitColumn";
import _InvoiceDetailInlineLabel from "styles-InvoiceDetailInlineLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailInlineLabel";
import _InvoiceAmountDueValue from "styles-InvoiceAmountDueValue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceAmountDueValue";
import _InvoiceLineItemsSection from "styles-InvoiceLineItemsSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsSection";
import _InvoiceLineItemsTable from "styles-InvoiceLineItemsTable.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsTable";
import _InvoiceLineItemsHeaderCellDescription from "styles-InvoiceLineItemsHeaderCellDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsHeaderCellDescription";
import _InvoiceLineItemsHeaderCellRight from "styles-InvoiceLineItemsHeaderCellRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsHeaderCellRight";
import _InvoiceLineItemsRow from "styles-InvoiceLineItemsRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsRow";
import _InvoiceLineItemsCellDescription from "styles-InvoiceLineItemsCellDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCellDescription";
import _InvoiceLineItemsCell from "styles-InvoiceLineItemsCell.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCell";
import _InvoiceLineItemsCellRight from "styles-InvoiceLineItemsCellRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCellRight";
import _InvoiceLineItemName from "styles-InvoiceLineItemName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemName";
import _InvoiceLineItemDescription from "styles-InvoiceLineItemDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemDescription";
import _InvoiceLineItemMobileMeta from "styles-InvoiceLineItemMobileMeta.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemMobileMeta";
import _InvoiceLineItemMobileMetaItem from "styles-InvoiceLineItemMobileMetaItem.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemMobileMetaItem";
import _InvoiceTotalsSection from "styles-InvoiceTotalsSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsSection";
import _InvoiceTotalsRow from "styles-InvoiceTotalsRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRow";
import _InvoiceTotalsRowDiscount from "styles-InvoiceTotalsRowDiscount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRowDiscount";
import _InvoiceTotalsRowTotal from "styles-InvoiceTotalsRowTotal.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRowTotal";
import _InvoiceTotalsLabel from "styles-InvoiceTotalsLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsLabel";
import _InvoiceTotalsValue from "styles-InvoiceTotalsValue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsValue";
import _InvoiceNotesSection from "styles-InvoiceNotesSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesSection";
import _InvoiceNotesLabel from "styles-InvoiceNotesLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesLabel";
import _InvoiceNotesBody from "styles-InvoiceNotesBody.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesBody";
import _SubmitErrorMessage from "styles-SubmitErrorMessage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=SubmitErrorMessage";
import _Footer from "styles-Footer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=Footer";
import _LogoWrapper from "styles-LogoWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=LogoWrapper";
import _FooterLinks from "styles-FooterLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FooterLinks";
import _FooterLink from "styles-FooterLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FooterLink";
import _RightColumnContent from "styles-RightColumnContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=RightColumnContent";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const colorBackgroundTertiary = 'var(--colorBackgroundTertiary, var(--coreColorNeutral300))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorTextDestructive = 'var(--colorTextDestructive, var(--coreColorRed700))'
const colorSurfaceSuccess = 'var(--colorSurfaceSuccess, var(--coreColorGreen700))'
const fontFamilyHeading = 'var(--fontFamilyHeading, "Proxima Nova", sans-serif)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
const fontSizeLabelMedium = 'var(--fontSizeLabelMedium, 0.75rem)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontSizeLarge = 'var(--fontSizeLarge, 1rem)'
const fontSizeTitleLarge = 'var(--fontSizeTitleLarge, 1.375rem)'
const lineHeightLabelMedium = 'var(--lineHeightLabelMedium, 1rem)'
const lineHeightLabelLarge = 'var(--lineHeightLabelLarge, 1.25rem)'
const lineHeightStandard = 'var(--lineHeightStandard, 1.5)'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
const fontWeightSemibold = 'var(--fontWeightSemibold, 600)'
const fontWeightBold = 'var(--fontWeightBold, 700)'

/** Invoice checkout card — desktop: max 1250px (822 + 428); paid-only single column caps at 800px */
export const ContentWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const LeftColumn = /*#__PURE__*/styled('div', null, {
  displayName: "LeftColumn",
  styles: _LeftColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const RightColumn = /*#__PURE__*/styled('div', null, {
  displayName: "RightColumn",
  styles: _RightColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const FormWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormWrapper",
  styles: _FormWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const StyledForm = /*#__PURE__*/styled(Form, null, {
  displayName: "StyledForm",
  styles: _StyledForm
})

export const PaymentSection = /*#__PURE__*/styled("div", null, {
  displayName: "PaymentSection",
  styles: _PaymentSection
})

export const PaymentSectionTitle = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentSectionTitle",
  styles: _PaymentSectionTitle
})

export const TotalDueSection = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueSection",
  styles: _TotalDueSection
})

export const TotalDueLabel = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueLabel",
  styles: _TotalDueLabel
})

export const TotalDueAmount = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueAmount",
  styles: _TotalDueAmount
})

export const FormFieldsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormFieldsWrapper",
  styles: _FormFieldsWrapper
})

export const BottomSection = /*#__PURE__*/styled('div', null, {
  displayName: "BottomSection",
  styles: _BottomSection
})

export const PageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "PageContainer",
  styles: _PageContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceHeader = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeader",
  styles: _InvoiceHeader,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderImageContainer",
  styles: _InvoiceHeaderImageContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImage = /*#__PURE__*/styled('img', null, {
  displayName: "InvoiceHeaderImage",
  styles: _InvoiceHeaderImage,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImagePlaceholder = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderImagePlaceholder",
  styles: _InvoiceHeaderImagePlaceholder
})

export const InvoiceHeaderRight = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderRight",
  styles: _InvoiceHeaderRight,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceNumberLabel = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceNumberLabel",
  styles: _InvoiceNumberLabel,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceLeftColumnContent = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLeftColumnContent",
  styles: _InvoiceLeftColumnContent
})

export const InvoicePaidWatermark = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePaidWatermark",
  styles: _InvoicePaidWatermark
})

export const InvoicePaidStamp = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePaidStamp",
  styles: _InvoicePaidStamp
})

export const InvoiceDetails = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetails",
  styles: _InvoiceDetails,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailLabel = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailLabel",
  styles: _InvoiceDetailLabel
})

export const InvoiceDetailBodyLine = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailBodyLine",
  styles: _InvoiceDetailBodyLine
})

export const InvoiceDetailColumn = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailColumn",
  styles: _InvoiceDetailColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailColumnRight = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailColumnRight",
  styles: _InvoiceDetailColumnRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailDateText = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailDateText",
  styles: _InvoiceDetailDateText
})

export const InvoiceDueDateBlock = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDueDateBlock",
  styles: _InvoiceDueDateBlock
})

export const InvoiceDetailDateSplitRow = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailDateSplitRow",
  styles: _InvoiceDetailDateSplitRow
})

export const InvoiceDetailDateSplitColumn = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailDateSplitColumn",
  styles: _InvoiceDetailDateSplitColumn
})

export const InvoiceDetailInlineLabel = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailInlineLabel",
  styles: _InvoiceDetailInlineLabel
})

export const InvoiceAmountDueValue = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceAmountDueValue",
  styles: _InvoiceAmountDueValue
})

export const InvoiceLineItemsSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemsSection",
  styles: _InvoiceLineItemsSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemsTable = /*#__PURE__*/styled('table', null, {
  displayName: "InvoiceLineItemsTable",
  styles: _InvoiceLineItemsTable
})

export const InvoiceLineItemsHeaderCellDescription = /*#__PURE__*/styled('th', null, {
  displayName: "InvoiceLineItemsHeaderCellDescription",
  styles: _InvoiceLineItemsHeaderCellDescription
})

const invoiceLineItemsNumericColumnWidth = '112px'

export const InvoiceLineItemsHeaderCellRight = /*#__PURE__*/styled('th', null, {
  displayName: "InvoiceLineItemsHeaderCellRight",
  styles: _InvoiceLineItemsHeaderCellRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemsRow = /*#__PURE__*/styled('tr', null, {
  displayName: "InvoiceLineItemsRow",
  styles: _InvoiceLineItemsRow
})

export const InvoiceLineItemsCellDescription = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCellDescription",
  styles: _InvoiceLineItemsCellDescription
})

export const InvoiceLineItemsCell = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCell",
  styles: _InvoiceLineItemsCell
})

export const InvoiceLineItemsCellRight = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCellRight",
  styles: _InvoiceLineItemsCellRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemName = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemName",
  styles: _InvoiceLineItemName
})

export const InvoiceLineItemDescription = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemDescription",
  styles: _InvoiceLineItemDescription
})

export const InvoiceLineItemMobileMeta = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemMobileMeta",
  styles: _InvoiceLineItemMobileMeta,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemMobileMetaItem = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceLineItemMobileMetaItem",
  styles: _InvoiceLineItemMobileMetaItem
})

export const InvoiceTotalsSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsSection",
  styles: _InvoiceTotalsSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceTotalsRow = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRow",
  styles: _InvoiceTotalsRow
})

export const InvoiceTotalsRowDiscount = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRowDiscount",
  styles: _InvoiceTotalsRowDiscount
})

export const InvoiceTotalsRowTotal = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRowTotal",
  styles: _InvoiceTotalsRowTotal
})

export const InvoiceTotalsLabel = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceTotalsLabel",
  styles: _InvoiceTotalsLabel
})

export const InvoiceTotalsValue = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceTotalsValue",
  styles: _InvoiceTotalsValue
})

export const InvoiceNotesSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesSection",
  styles: _InvoiceNotesSection
})

export const InvoiceNotesLabel = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesLabel",
  styles: _InvoiceNotesLabel
})

export const InvoiceNotesBody = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesBody",
  styles: _InvoiceNotesBody
})

export const SubmitErrorMessage = /*#__PURE__*/styled('div', null, {
  displayName: "SubmitErrorMessage",
  styles: _SubmitErrorMessage
})

export const Footer = /*#__PURE__*/styled('div', null, {
  displayName: "Footer",
  styles: _Footer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const LogoWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "LogoWrapper",
  styles: _LogoWrapper
})

export const FooterLinks = /*#__PURE__*/styled('div', null, {
  displayName: "FooterLinks",
  styles: _FooterLinks
})

export const FooterLink = /*#__PURE__*/styled('button', null, {
  displayName: "FooterLink",
  styles: _FooterLink
})

export const RightColumnContent = /*#__PURE__*/styled('div', null, {
  displayName: "RightColumnContent",
  styles: _RightColumnContent,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

